module.exports = {"baseUrl":"https://i2ocgold.com","downloadButton":{"enable":true,"postgresUrl":null,"i2ocApplicationUrl":null}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 221
// module chunks = 1